import { xxllncColor, themeColor } from '../../layout/theme/color'

export const WORKFLOW = {
  trigger: {
    accent: xxllncColor.green100,
    bg: xxllncColor.opGreen10,
    border: xxllncColor.opGreen20,
  },
  // eslint-disable-next-line camelcase
  tool_call: {
    accent: xxllncColor.dark100,
    bg: xxllncColor.opDark10,
    border: xxllncColor.opDark20,
  },
  // eslint-disable-next-line camelcase
  ai_call: {
    accent: '#6366F1',
    bg: 'rgba(99,102,241,0.06)',
    border: 'rgba(99,102,241,0.15)',
  },
  condition: {
    accent: xxllncColor.yellow100,
    bg: xxllncColor.opYellow20,
    border: xxllncColor.opYellow20,
  },
  loop: {
    accent: '#7C3AED',
    bg: 'rgba(124,58,237,0.06)',
    border: 'rgba(124,58,237,0.15)',
  },
  transform: {
    accent: xxllncColor.dark60,
    bg: xxllncColor.opDark10,
    border: xxllncColor.opDark10,
  },
  fieldMapping: {
    accent: '#0EA5E9',
    bg: 'rgba(14,165,233,0.06)',
    border: 'rgba(14,165,233,0.15)',
  },
  // eslint-disable-next-line camelcase
  field_mapping: {
    accent: '#0EA5E9',
    bg: 'rgba(14,165,233,0.06)',
    border: 'rgba(14,165,233,0.15)',
  },
  merge: {
    accent: xxllncColor.orange100,
    bg: xxllncColor.opOrange20,
    border: xxllncColor.opOrange20,
  },
  visualization: {
    accent: '#0D9488',
    bg: 'rgba(13,148,136,0.06)',
    border: 'rgba(13,148,136,0.15)',
  },
  data: {
    accent: '#9333EA',
    bg: 'rgba(147,51,234,0.06)',
    border: 'rgba(147,51,234,0.15)',
  },
  parse: {
    accent: '#DB2777',
    bg: 'rgba(219,39,119,0.06)',
    border: 'rgba(219,39,119,0.15)',
  },
  // eslint-disable-next-line camelcase
  data_store_write: {
    accent: '#15803D',
    bg: 'rgba(21,128,61,0.06)',
    border: 'rgba(21,128,61,0.15)',
  },
  // eslint-disable-next-line camelcase
  data_store_read: {
    accent: '#0F766E',
    bg: 'rgba(15,118,110,0.06)',
    border: 'rgba(15,118,110,0.15)',
  },
  // eslint-disable-next-line camelcase
  data_store_update: {
    accent: '#B45309',
    bg: 'rgba(180,83,9,0.06)',
    border: 'rgba(180,83,9,0.15)',
  },
  // eslint-disable-next-line camelcase
  data_store_delete: {
    accent: '#B91C1C',
    bg: 'rgba(185,28,28,0.06)',
    border: 'rgba(185,28,28,0.15)',
  },
  // eslint-disable-next-line camelcase
  data_store: {
    accent: '#0F766E',
    bg: 'rgba(15,118,110,0.06)',
    border: 'rgba(15,118,110,0.15)',
  },

  canvas: {
    bg: themeColor.slate05,
    gridColor: 'rgba(0,0,0,0.04)',
    gridSize: 20,
  },

  node: {
    width: 280,
    minHeight: 80,
    borderRadius: '14px',
    borderWidth: 4,
    handleSize: 10,
  },

  sidebar: {
    width: 260,
  },

  configPanel: {
    width: 340,
  },
} as const
